import { COLOR_SALMON, COLOR_WHITE } from '../colors';

const palettes = {
    anniemac                              : ['#19244E', '#00A551'],
    baird_warner                          : ['#003747', '#E5A505'],
    berkshire_hathaway                    : ['#670038','#ffffff'],
    better_homes_gardens                  : ['#414042'],
    black                                 : ['#1a1a1a'],
    brick                                 : [COLOR_SALMON],
    broker_solutions_new_american_funding : ['#f6f6f6', '#17689a'],
    caliber_home_loans                    : ['#385988'],
    century21                             : ['#38383a', '#beaf87'],
    clearview_realty                      : ['#0c3764', '#ffffff'],
    coldwell_banker                       : ['#012169'],
    corcoran                              : ['#dddddd', '#000000'],
    cross_country_mortgage                : ['#008060'],
    era_real_estate                       : ['#250e62'],
    exp_realty                            : ['#0066cc', '#f5821e'],
    fairway_independent_mortgage          : ['#115740', '#95c94f'],
    grey                                  : ['#e0e0e0', '#a1a1a1'],
    guaranteed_rate                       : ['#25282a', '#d1333b'],
    guild_mortgage_company                : ['#ffdf00', '#262a82'],
    iron_valley_realtors                  : ['#151515', '#a56a41'],
    jack_conway_realtors                  : ['#ec2125', '#ffffff'],
    keller_williams                       : ['#b22222'],
    loan_depot                            : ['#5c2d91'],
    minty                                 : ['#54d0aa'],
    movement_mortgage                     : ['#c8102e'],
    nexthome                              : ['#ff6c2c'],
    ocean                                 : ['#003258', '#00a7da'],
    one_stop_realty                       : ['#b22222'],
    pool                                  : ['#1ec8e1', '#1c3039'],
    prmg                                  : ['#183ca7', '#f08b34'],
    prudential                            : ['#552448'],
    realty_one                            : ['#3d3d3d', '#c5a95e'],
    remax                                 : ['#003da5'],
    sereno                                : ['#001231', '#EFEBE7'],
    sothebys                              : ['#324b72'],
    yellow                                : ['#ffc85a', '#f3291d'],
    watson_realty                         : ['#23346d'],
    weichert                              : ['#191a25', '#f1c40f'],
    william_raveis                        : ['#5d89b3', '#fefefe'],
    williams_stuart                       : ['#1a3560', '#ffc20e'],
    primary_residential_mortgage_inc      : ['#50758a', '#ffffff'],
    residential_properties_ltd            : ['#116263', '#fdfefe'],
    nationwide_mortgage_bankers           : ['#364C89', '#ffffff'],
};

export const getPalette = (theme, palette = [])=> {
    let [
        primaryColor = COLOR_SALMON,
        secondaryColor = COLOR_WHITE
    ] = palette || [];
    if(palettes[theme]) {
        [ primaryColor, secondaryColor = COLOR_WHITE ] = palettes[theme];
    }
    return { primaryColor, secondaryColor };
};
